/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */ 
var styles = [".alert-mkt[_ngcontent-%COMP%]{background-color:#a7d0ee!important;border-color:#a7d0ee!important}"];
export { styles as styles };
//# sourceMappingURL=mkt-banner.component.scss.shim.ngstyle.js.map


//////////////////
// WEBPACK FOOTER
// ./ts/app/home/mkt-banner/mkt-banner.component.scss.shim.ngstyle.js
// module id = 1552
// module chunks = 27 28 29